import ValidationUtils from './ValidationUtils';

const REQUIRED_ERROR_MESSAGE = 'This value is required';

const ResetPasswordValidator = (values) => {
  const requiredFields = [{
    name: 'password',
    errorMessage: REQUIRED_ERROR_MESSAGE
  }, {
    name: 'confirmPassword',
    errorMessage: REQUIRED_ERROR_MESSAGE
  }];

  const errors = ValidationUtils.validateRequiredFields(requiredFields, values);

  if (values.password && !ValidationUtils.hasUpperCaseCharacter(values.password)) {
    errors.password = 'Password must contain an uppercase letter';
  }

  if (values.password && !ValidationUtils.containsNumber(values.password)) {
    errors.password = 'Password must contain a number';
  }

  if (values.password && values.password.length < 8) {
    errors.password = 'Password must be at least 8 characters';
  }

  if (values.password && values.confirmPassword && values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Passwords must match';
  }

  return errors;
};

export default ResetPasswordValidator;



/** WEBPACK FOOTER **
 ** ./src/common/validation/ResetPasswordValidator.js
 **/